// custom-autoplay.js
(function () {
  const AUTOPLAY_DELAY_MS = 2000; // 2 seconds

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function inViewport(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.height > 0 && rect.width > 0 &&
           rect.bottom > 0 && rect.right > 0 &&
           rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
           rect.left < (window.innerWidth || document.documentElement.clientWidth);
  }

  function userIsTyping() {
    const el = document.activeElement;
    if (!el) return false;
    const tag = el.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
  }

  function startNativeSliderAutoplay(root) {
    const nextBtn = root.querySelector('.slider-button--next, [data-slider-button="next"]');
    if (!nextBtn) return null;

    let hovering = false;
    let timer = null;

    function tick() {
      if (!hovering && !userIsTyping() && !document.hidden && inViewport(root)) {
        nextBtn.click();
      }
      timer = setTimeout(tick, AUTOPLAY_DELAY_MS);
    }

    root.addEventListener('mouseenter', () => { hovering = true; });
    root.addEventListener('mouseleave', () => { hovering = false; });

    timer = setTimeout(tick, AUTOPLAY_DELAY_MS);
    return () => clearTimeout(timer);
  }

  function startSwiperAutoplay(root) {
    const container = root.matches('.swiper') ? root : root.querySelector('.swiper, .swiper-container');
    if (!container) return null;
    const inst = container.swiper;
    if (!inst) return null;

    inst.params.autoplay = inst.params.autoplay || {};
    inst.params.autoplay.delay = AUTOPLAY_DELAY_MS;
    inst.params.autoplay.disableOnInteraction = false;
    inst.autoplay && inst.autoplay.start && inst.autoplay.start();

    let paused = false;
    function pause() { if (!paused) { paused = true; inst.autoplay.stop(); } }
    function resume() { if (paused && !document.hidden && inViewport(container)) { paused = false; inst.autoplay.start(); } }

    container.addEventListener('mouseenter', pause);
    container.addEventListener('mouseleave', resume);
    document.addEventListener('visibilitychange', () => (document.hidden ? pause() : resume()));

    return () => { try { inst.autoplay.stop(); } catch(e){} };
  }

  function startFlickityAutoplay(root) {
    const el = root.matches('.flickity-enabled') ? root : root.querySelector('.flickity-enabled');
    const flkty = el && el.flickity || (window.Flickity && window.Flickity.data && el ? window.Flickity.data(el) : null);
    if (!flkty) return null;

    try {
      flkty.options.autoPlay = AUTOPLAY_DELAY_MS;
      flkty.options.pauseAutoPlayOnHover = true;
      flkty.playPlayer && flkty.playPlayer();
    } catch (e) {}

    return () => { try { flkty.stopPlayer && flkty.stopPlayer(); } catch(e){} };
  }

  function tryStart(root) {
    if (root.__autoplayBound) return;
    root.__autoplayBound = true;

    const cleanup =
      startSwiperAutoplay(root) ||
      startFlickityAutoplay(root) ||
      startNativeSliderAutoplay(root);

    root.__autoplayCleanup = cleanup;
  }

  function findSlideshows(ctx = document) {
    return Array.from(ctx.querySelectorAll(
      'slideshow-component, slider-component, [data-slideshow], .swiper, .swiper-container, .flickity-enabled'
    ));
  }

  function init(ctx) {
    const sliders = findSlideshows(ctx);
    if (!sliders.length) return;
    tryStart(sliders[0]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

})();